import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react'
import { Card, Col, Row, Input, Label, Button } from 'reactstrap'
import { faWindowClose } from "@fortawesome/free-solid-svg-icons/faWindowClose";
import ReactQuill from 'react-quill';


import { connect } from "react-redux";
import AddNewTaskServices from '../../../../../../Service/OPSServices/SWInternalServices/AddNewTaskServices';
import { Editor } from '../../../../../../Utils/Constants';
import TasksDatePicker from '../../../../../Components/Input/TasksDatePicker';
import CustomModal from '../../../../../Components/Modals/CustomModal';
import FetchStoresListService from '../../../../../../Service/OPSServices/SWInternalServices/FetchStoresListService';
import NewTaskProductList from './NewTaskProductList';
import FetchProductDataService from '../../../../../../Service/OPSServices/SWInternalServices/FetchProductDataService';
import NewTaskIcon from '../../../../../../designUtils/OpsDashboard/MyTasks/NewTaskIcon.svg';



function CreateNewTask(props) {
    const [newTask, setNewTask] = useState('');
    const [referenceText, setReferenceText] = useState('')
    const [selectedFiles, setSelectedFiles] = useState([])
    const [text, setText] = useState('')
    const [taskStatus, setTaskStatus] = useState('');
    const [member, setMember] = useState();
    const [saveLoading, setSaveLoading] = useState(false)
    const [errors, setErrors] = useState({})
    const [selectedMembers, setSelectedMembers] = useState(props.loggedUserId);
    const [taskPriority, setTaskPriority] = useState('Normal')
    const [addProductsPopup, setAddProductsPopup] = useState(false)
    const [intergerId, setIntergerId] = useState()
    const [storeList, setStoreList] = useState()
    const [storeListForInternaluser, setStoreListForInternaluser] = useState()
    const [productList, setProductList] = useState()
    const [asinList, setAsinList] = useState([])
    const [selectedStoreName, setSelectedStoreName] = useState('');
    const [selectedSignedOffBy, setSelectedSignedOffBy] = useState(props.loggedUserId);
    const [user, setUser] = useState();
    const [userMap, setUserMap] = useState()
    const [allStores, setAllStores] = useState([]);      // complete distinct store list
    const [agencyMemberList,setAgencyMemberList]= useState(props.agencyMemberList)






    const [dateRange, setDateRange] = useState({
        startDate: new Date(),
        endDate: new Date(),
    });

    const formattedDate = dateRange.startDate ? dateRange.startDate.toLocaleDateString('en-US') : ''; // Format depends on the locale
    const hours = dateRange.startDate.getHours().toString().padStart(2, '0');
    const minutes = dateRange.startDate.getMinutes().toString().padStart(2, '0');
    const seconds = dateRange.startDate.getSeconds().toString().padStart(2, '0');
    const currentTime = `${hours}:${minutes}:${seconds}`;

    // Combine the original date with the current time
    const updatedDate = formattedDate.split(' ')[0] + ' ' + currentTime + formattedDate.slice(19);
    const updateDate = updatedDate


    const endformattedDate = dateRange.endDate ? dateRange.endDate.toLocaleDateString('en-US') : ''; // Format depends on the locale
    const endhours = dateRange.endDate.getHours().toString().padStart(2, '0');
    const endminutes = dateRange.endDate.getMinutes().toString().padStart(2, '0');
    const endseconds = dateRange.endDate.getSeconds().toString().padStart(2, '0');
    const endcurrentTime = `${endhours}:${endminutes}:${endseconds}`;

    // Combine the original date with the current time
    const endupdatedDate = endformattedDate.split(' ')[0] + ' ' + endcurrentTime + endformattedDate.slice(19);

    const handleDateRangeChange = (newDateRange) => {
        setDateRange(newDateRange);
    };

    // console.log(dateRange.startDate);

    const handleRemoveFile = (file) => {
        const updatedFiles = selectedFiles.filter((f) => f !== file);
        setSelectedFiles(updatedFiles);
    };
    const handleSubmitSwTask = () => {
        const newErrors = {};

        if (!dateRange.startDate) {
            newErrors.startDate = 'Start date and End date are required';
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        setSaveLoading(true)
        const formData = new FormData();
        formData.append("taskTitle", newTask);
        formData.append("referenceText", referenceText);
        formData.append("status", 'new');
        formData.append("Comments", text);
        formData.append("startDate", updateDate);
        formData.append("asinList", asinList);
        formData.append("intergerId", intergerId);
        formData.append("endDate", endupdatedDate);
        formData.append("assignedTo", member ? member : selectedMembers);
        formData.append('taskPriority', taskPriority)
        formData.append('signedOffBy', user ? user : selectedSignedOffBy)

        if (selectedFiles.length > 0) {
            for (let i = 0; i < selectedFiles.length; i++) {
                formData.append("taskAttachmentFile", selectedFiles[i]);
            }
        }
        else {
            formData.append("taskAttachmentFile", []);
        }
        AddNewTaskServices(props.token, formData).then((res) => {
            if (res) {
                console.log(res)
                setText('')
                // setDateRange({
                //     startDate: null,
                //     endDate: null,
                // });
                setSelectedFiles([])
                setTaskStatus('')
                setNewTask('')
                setMember([])
                setUser([])
                props.handleCloseCreateTaskPopup(res.tasklist)
            }
            setSaveLoading(false)
            // window.location.reload();

        })

    }

    const handleQuillChange = (value) => {
        setText(value);
    };
    useEffect(() => {
        FetchStoresListService(props.token).then((res) => {
            if (res) {
                console.log(res);
                if(props.accessLevel !==0){
                    const distinctStores = Object.values(
                        res.storeListData.filter(item => item.simpliUser === props.loggedUserId)
                            .reduce((acc, item) => {
                                acc[item.integerId] = { integerId: item.integerId, name: item.name, simpliUser: item.simpliUser };
                                return acc;
                            }, {})
                    );
    
                    setStoreList(distinctStores);
                    setAllStores(distinctStores);
                    setUserMap(res.storeListData);
                }
                else{
                    setStoreListForInternaluser(res.storeListData);
                setAllStores(res.storeListData);
                setUserMap(res.storeListData);

                }
                

                
            }
        });
    }, []);

    const handleAssignedToChange = (e) => {
        const selectedUserId = Number(e.target.value);

        const mappedStoreIds =  userMap &&userMap
            .filter(item => item.simpliUser === selectedUserId)
            .map(item => item.integerId);
        const filteredStores = allStores.filter(store =>
            mappedStoreIds.includes(store.integerId)
        );
        setStoreList(filteredStores);
        setSelectedMembers(selectedUserId);
     
            setSelectedStoreName("");
            setIntergerId("");
            setAsinList([""]);
            setAgencyMemberList(props.agencyMemberList);

    };


    const handleSignedOffBy = (e) => {
        const value = e.target.value;
        console.log(value)

        setSelectedSignedOffBy(value);
    };
    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        setSelectedFiles((prevFiles) => [...prevFiles, ...files]);
    };

    const handlePriorityChange = (e) => {
        setTaskPriority(e.target.value)
        console.log(e.target.value);
    }
  
       
    const handleStoreChange = (e) => {
            const selectedValue = e.target.value;
            console.log(selectedValue);
            console.log(typeof(selectedValue));
            if (!selectedValue) {
                // Reset everything when "--Select Store--" is chosen
                setSelectedStoreName("");
                setIntergerId("");
                setAsinList([""]);
                setAgencyMemberList(props.agencyMemberList);
                return;  // STOP here
            }
            // if (selectedValue !== '' && selectedValue !== null) {

                console.log("Selected store ID:", selectedValue);
        
                // 1. Find store name
                const selectedStore = storeList.find(
                    store => store.integerId.toString() === selectedValue
                );
            
                setSelectedStoreName(selectedStore ? selectedStore.name : "");
            
            
                // 2. Filter userMap for this store
                const signedOffByfilter = userMap.filter(
                    store => store.integerId.toString() === selectedValue
                );
            
                // 3. Extract unique user IDs
                const userIds = [...new Set(signedOffByfilter.map(u => u.simpliUser))];
            
                // 4. Filter agency members by these user IDs
                const filteredUsers = props.agencyMemberList.filter(
                    user => userIds.includes(user.id)
                );
            
                // 5. Update dropdown list
                setAgencyMemberList(filteredUsers);
            
                // 6. Set store and reset ASIN
                setIntergerId(selectedValue);
                setAsinList(['']);
            // }
            // else{
            //     setAgencyMemberList(props.agencyMemberList);
            // }

           
      
        
    };
    const handleStoreChangeInternalUser=(e)=>{
        console.log(e.target.value)
        const selectedStore = storeListForInternaluser.find(store => store.integerID.toString() === e.target.value);
    
        if (selectedStore) {
            setSelectedStoreName(selectedStore.name);
        } else {
            setSelectedStoreName('');
        }
        setIntergerId(e.target.value)
        setAsinList([''])
    }


    const handleSelectProduct = () => {
        let data = {
            integerID: intergerId
        }
        FetchProductDataService(props.token, data).then((res) => {
            if (res) {
                console.log(res)
                setProductList(res.productsList)
                setAddProductsPopup(true)
            }
        })
    }
    const setSelectedAsin = (data) => {
        console.log(data)
    }

    return (
        <>
            <Card className='card-of-problemarea p-4'>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={4}>
                                <Label> <b>Task Title :<span style={{ color: "red" }}
                                > * </span></b>  </Label>
                                <Input
                                    type='text'
                                    className='w-100'
                                    placeholder='Enter Text'
                                    onChange={(e) => setNewTask(e.target.value)}
                                />

                            </Col>
                            <Col md={4}>
                                <Label> <b>Reference :</b>  </Label>
                                <Input
                                    type='text'
                                    className='w-100'
                                    placeholder='Enter Text'
                                    onChange={(e) => setReferenceText(e.target.value)}
                                />

                            </Col>
                            <Col md={4}>
                                <Label><b>Priority :</b></Label>
                                <select
                                    id="priority"
                                    name="priority"
                                    onChange={handlePriorityChange}
                                    value={taskPriority}
                                    className="form-control"
                                >
                                    <option disabled selected value="">--Select Priority--</option>
                                    <option value="Critical">Critical</option>
                                    <option value="Urgent">Urgent</option>
                                    <option value="High">High</option>
                                    <option value="Normal">Normal</option>
                                    <option value="Low">Low</option>
                                </select>
                            </Col>

                        </Row>
                    </Col>
                    <Col md={12}>
                        <Row className='mt-3'>
                            <Col md={4}>
                                {/* <select
                                    id='assigned To'

                                    onChange={(e) => handleAssignedToChange(e)

                                    }
                                    className='form-control w-100'>
                                    <option id='' value=''>--Assigned To--</option>
                                    {props.teamMemberList && props.teamMemberList.map((member) => (
                                        <option
                                            key={member.employeeId}
                                            value={member.employeeId}
                                        // selected={member.employeeId}
                                        >{member.employeeName}</option>
                                    ))}
                                </select> */}

                                <Label><b>Assigned To :</b></Label>
                                {props.accessLevel === 0 ?
                                    <select
                                        id="assignedTo"
                                        onChange={(e) => handleAssignedToChange(e)}
                                        className="form-control w-100"
                                        value={selectedMembers}
                                    // value={props.loggedUserId?props.loggedUserId:selectedMembers}
                                    >
                                        <option disabled selected value="">-- Select Assigned To --</option>
                                        {props.teamMemberList &&
                                            props.teamMemberList.map((member) => (
                                                <option key={member.employeeId} value={member.employeeId} title={member.email}>
                                                    {member.employeeName}
                                                </option>
                                            ))}
                                    </select> :
                                    <select
                                        id="assignedTo"
                                        onChange={(e) => handleAssignedToChange(e)}
                                        className="form-control w-100"
                                        value={selectedMembers}
                                    // value={props.loggedUserId?props.loggedUserId:selectedMembers}
                                    >
                                        <option disabled selected value="">-- Select Assigned To --</option>
                                        {props.agencyMemberList &&
                                            props.agencyMemberList.map((agencymember) => (
                                                <option key={agencymember.id} value={agencymember.id} title={agencymember.email}>
                                                    {agencymember.name}
                                                </option>
                                            ))}
                                    </select>
                                }


                            </Col>
                            <Col md={4}>
                                <Label><b>Sign Off:</b></Label>
                                {props.accessLevel === 0 ?
                                    <select
                                        id="assignedTo"
                                        onChange={(e) => handleSignedOffBy(e)}
                                        className="form-control w-100"
                                        value={selectedSignedOffBy}
                                    // value={props.loggedUserId?props.loggedUserId:selectedMembers}
                                    >
                                        <option disabled selected value="">-- Select User--</option>
                                        {props.teamMemberList &&
                                            props.teamMemberList.map((user) => (
                                                <option key={user.employeeId} title={user.email} value={user.employeeId}>
                                                    {user.employeeName}
                                                </option>
                                            ))}
                                    </select> :
                                    <select
                                        id="assignedTo"
                                        onChange={(e) => handleSignedOffBy(e)}
                                        className="form-control w-100"
                                        value={selectedSignedOffBy}
                                    // value={props.loggedUserId?props.loggedUserId:selectedMembers}
                                    >
                                        <option disabled selected value="">-- Select User--</option>
                                        {agencyMemberList &&
                                            agencyMemberList.map((user) => (
                                                <option key={user.id} title={user.email} value={user.id}>
                                                    {user.name}
                                                </option>
                                            ))}
                                    </select>}

                            </Col>
                            <Col md={4}>
                                <TasksDatePicker
                                    dateRange={dateRange}
                                    setDateRange={handleDateRangeChange}
                                />
                                {dateRange.startDate == null ? <span style={{ color: 'red' }}>{errors.startDate}</span> : ''}
                            </Col>
                        </Row>
                    </Col>
                    <Col className='mt-2' md={6}>
                        <Row>
                            <Col md={6}>
                                <p for="Attachment">
                                    <b>Upload Helpful Files : </b>
                                </p>
                                <label
                                    htmlFor="fileInput"
                                    className="custom-file-input-label text-center"
                                    style={{ height: '72px' }}
                                >
                                    <i className="fas fa-upload mt-3" style={{ fontSize: '20px' }}></i>
                                    <br /> Choose File

                                    <input
                                        type="file"
                                        id="fileInput"
                                        name="ticketAttachment"
                                        className="custom-file-input"
                                        onChange={handleFileChange}
                                        multiple
                                    />
                                </label>
                            </Col>
                            <Col md={6}>
                                <span style={{ fontSize: "14px" }}><b>Attached File List :</b></span>
                                <ul style={{
                                    color: "green", fontSize: "13px", maxHeight: '110px',
                                    overflowY: 'auto'
                                }}>
                                    {selectedFiles
                                        ? selectedFiles.map((file, index) => (
                                            <li key={index}><div className='d-flex'>
                                                <p title={file.name} className='mb-0 mt-2 comment-paragraph-taskfiles'>{file.name}</p>
                                                <button
                                                    className="btn"
                                                    onClick={() => handleRemoveFile(file)}
                                                >
                                                    <FontAwesomeIcon
                                                        color="red"
                                                        size="15px"
                                                        icon={faWindowClose}
                                                    />
                                                </button></div>
                                            </li>
                                        ))
                                        : ""}
                                </ul>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={6} className='mt-2'>
                        <Row>
                            <Col md={7}>
                                <span style={{ fontSize: "14px" }}><b>Store :</b></span>
                              {props.accessLevel ==0?
                              <select 
                              id="StoreList"
                              name="StoreList"
                              onChange={handleStoreChangeInternalUser}
                              value={intergerId}
                              className="form-control mt-2"
                          >
                              <option value="">--Select Store--</option>
                          
                              {storeListForInternaluser &&storeListForInternaluser.map((store) => (
                                  <option key={store.integerID} value={store.integerID}>
                                      {store.name}
                                  </option>
                              ))}
                          </select>
                                    :                          
                                <select
                                    id="StoreList"
                                    name="StoreList"
                                    onChange={ handleStoreChange}
                                    value={intergerId}    // corrected variable name
                                    className="form-control mt-2"
                                >
                                    <option value="">--Select Store--</option>
                                    {storeList && storeList.map((store) => (
                                        <option key={store.integerId} value={store.integerId}>  {/* corrected key & value */}
                                            {store.name}
                                        </option>
                                    ))}
                                </select>}

                                <Button
                                    className="btn-background-color w-100 mt-2"
                                    onClick={() => handleSelectProduct()}
                                    disabled={!intergerId}   // corrected variable name
                                >
                                    Add Products
                                    <img className='ml-2 mb-1' src={NewTaskIcon} style={{ height: '18px' }} />
                                </Button>
                            </Col>

                            <Col md={5} >
                                <p className='mb-1' style={{ fontSize: "14px" }}><b className='mb-1' >Asins List :</b></p>
                                <div style={{
                                    maxHeight: '105px',
                                    overflowY: 'auto',
                                }}>
                                    {asinList && asinList.map((asin) => {
                                        const product = productList && productList.find(p => p.asin === asin);
                                        return (
                                            <p key={asin} title={product && product.productTitle || 'Product title not found'}>
                                                {asin}
                                            </p>
                                        );
                                    })}

                                </div>


                            </Col>
                        </Row>

                    </Col>
                    <Col md={12} className='mt-2 '>
                        <Label><b>Add Note For Task :<span style={{ color: 'red' }}> *</span></b></Label>
                        <ReactQuill
                            className=""
                            theme={'snow'}
                            modules={Editor.modules}
                            formats={Editor.formats}
                            value={text}
                            onChange={handleQuillChange}
                            bounds={'.quill-prod'}
                            placeholder='Note' />
                    </Col>
                    <Col md={12} className='d-flex justify-content-center mt-2'>
                        <Button
                            className='btn-background-color '
                            disabled={!(newTask && text) || saveLoading}
                            onClick={() => handleSubmitSwTask()}>
                            {saveLoading ? 'Saving..' : 'Save'}
                        </Button>
                    </Col>
                </Row>
            </Card>
            <CustomModal
                header={
                    <span>
                        Add Products for : <b>{selectedStoreName || ''}</b>
                    </span>
                }
                isOpen={addProductsPopup}
                toggle={() => {
                    setAddProductsPopup(!addProductsPopup); setAsinList([''])
                    //   setEmailRecipient('')
                    //   // setSelectedStore({ integerId: '' });
                    //   setSelectedStoreData({ integerId: '', storeName: '' });
                }}
                size={"lg"}
                className='my-task-custom-module'
            >
                <NewTaskProductList
                    setAddProductsPopup={setAddProductsPopup}
                    asinList={asinList}
                    setAsinList={setAsinList}
                    setSelectedAsin={setSelectedAsin}
                    productList={productList}
                />

            </CustomModal>
        </>
    )
}
const mapStateToProps = (state) => {
    return {
        token: state.loggedUser.token,
        accessLevel: state.loggedUser.accessLevel,
        status: state.loggedUser.status,
        error: state.loggedUser.error,

    };
};

export default connect(mapStateToProps)(CreateNewTask);
